'use strict'

/**
 * Constructor for Polygon objects to hold data for all drawn objects.
 * For now they will just be defined as rectangles.
 */
class Polygon {
    /**
     *  This is a very simple and unsafe constructor. All we're doing is checking if the values exist.
     *  "x || 0" just means "if there is a value for x, use that. Otherwise use 0."
     *  But we aren't checking anything else! We could put "Lalala" for the value of x
     * @param  {[type]} x    [description]
     * @param  {[type]} y    [description]
     * @param  {[type]} w    [description]
     * @param  {[type]} h    [description]
     * @param  {[type]} r    [description]
     * @param  {[type]} g    [description]
     * @param  {[type]} b    [description]
     * @param  {[type]} fill [description]
     * @return {[type]}      [description]
     */
    constructor({
        x,
        y,
        color,
        ctx,
        viewimage_draw,
        numcolor,
        mindist, // actually it's just the image ratio
    }) {
        this.dots = [] // List of coordinates x,y
        this.data = [] // Data from canvas - list of bytes
        this.color = color
        this.viewimage_draw = viewimage_draw

        this.x = x || 0
        this.y = y || 0
        this.ctx = ctx
        this.mindist = 4 * mindist // minimum distance between start and stop point
        this.numcolor = parseInt(numcolor)
        this.fill = '#AAAAAA'

        // Add new coordinates
        this.add(x, y)

        // Draw line and basics parameters
        this.ctx.beginPath()
        this.ctx.lineWidth = 2
        this.ctx.fillStyle = '#e74c3c'
        this.ctx.strokeStyle = this.fill
        this.ctx.globalAlpha = 0.6
        this.ctx.moveTo(x, y)
    }

    changeColor(r, g, b) {
        this.r = r
        this.g = g
        this.b = b
    }

    // Add coordinates to canvas then draw it
    add(x, y) {
        this.dots.push({ x: x, y: y })
        this.draw()
    }

    getColoredPixel() {
        const data = this.ctx.getImageData(0, 0, this.viewimage_draw.width, this.viewimage_draw.height).data

        let positions = new Map()

        for (let i = 0; i < data.length; i += 4) {
            if (data[i] !== 0) {
                const x = Number((i / 4) % this.viewimage_draw.width)
                const y = Number((i / 4 / this.viewimage_draw.width).toFixed(0))

                positions.set(y * this.viewimage_draw.width + x, {
                    x: x,
                    y: y,
                })
            }
        }
        return positions
    }

    // Draw final polygon

    /**
     * Computer 3 arrays containing pixels of the polygon
     *
     * return :
     * borderPixels : border of the polygon
     * fillPixel: inner pixel of polygon(no border)
     * fullPixel: whole polygon
     *
     * needToFillpolygon : if polygone -> true, if line -> false
     * @param {*} fill
     */
    finish() {
        console.log('stop fill')
        // Clear canvas
        this.ctx.clearRect(0, 0, this.viewimage_draw.width, this.viewimage_draw.height)

        // Draw final polygon (without circles)
        this.ctx.beginPath()
        this.ctx.moveTo(this.dots[0].x, this.dots[0].y)

        // Draw each dots
        for (let i = 1; i < this.dots.length; i++) {
            let d = this.dots[i]
            this.ctx.lineTo(d.x, d.y)
        }

        this.ctx.strokeStyle = 'red'
        this.ctx.lineWidth = 2

        this.ctx.stroke()

        // ---------------------------------------------------
        // Filled coordinated
        // ---------------------------------------------------

        // Clear canvas
        this.ctx.clearRect(0, 0, this.viewimage_draw.width, this.viewimage_draw.height)

        // Draw final polygon (without circles)
        this.ctx.beginPath()
        this.ctx.moveTo(this.dots[0].x, this.dots[0].y)

        // Draw each dots
        for (let i = 1; i < this.dots.length; i++) {
            let d = this.dots[i]
            this.ctx.lineTo(d.x, d.y)
        }

        this.ctx.strokeStyle = 'red'
        this.ctx.lineWidth = 2

        this.ctx.fillStyle = 'red'
        this.ctx.fill()
        this.ctx.stroke()

        // Full polygon (border + inner polygon pixels)
        const fullPixel = this.getColoredPixel()

        // borderPixels : border of the polygon
        // fillPixel : inner pixel of polygon (no border)
        // fullPixel : whole polygon
        return fullPixel
    }

    clear() {
        // Clear screen
        this.ctx.clearRect(0, 0, this.viewimage_draw.width, this.viewimage_draw.height)
    }

    /**
     * Draws this polygon to a given context
     * @param  {[type]} ctx [description]
     * @return {[type]}     [description]
     */
    draw({ fillColor } = {}) {
        // Clear screen
        this.ctx.clearRect(0, 0, this.viewimage_draw.width, this.viewimage_draw.height)

        // Fill polygon
        this.ctx.beginPath()
        this.ctx.moveTo(this.dots[0].x, this.dots[0].y)

        for (let i = 1; i < this.dots.length; i++) {
            let d = this.dots[i]
            this.ctx.lineTo(d.x, d.y)
        }
        this.ctx.fillStyle = fillColor || this.previewFillColor || '#e74c3c'
        this.ctx.fill()

        // Fill lines
        this.ctx.beginPath()
        this.ctx.strokeStyle = 'black'

        this.ctx.moveTo(this.dots[0].x, this.dots[0].y)

        for (let i = 1; i < this.dots.length; i++) {
            let d = this.dots[i]
            this.ctx.lineTo(d.x, d.y)
        }
        this.ctx.stroke()
    }

    // Get last dots X
    lastDotX() {
        return this.dots[this.dots.length - 1].x
    }

    // Get last dots Y
    lastDotY() {
        return this.dots[this.dots.length - 1].y
    }

    distance(x, y) {
        let min_dist = this.mindist
        let origin_x = this.dots[0].x
        let origin_y = this.dots[0].y

        let d_x = Math.abs(origin_x - x)
        let d_y = Math.abs(origin_y - y)

        if (d_x < min_dist && d_y < min_dist) {
            return true
        }

        return false
    }

    /**
     * Determine if a point is inside the polygon's bounds
     * @param  {[type]} mx [description]
     * @param  {[type]} my [description]
     * @return {[type]}    [description]
     */
    contains(mx, my) {
        // All we have to do is make sure the Mouse X,Y fall in the area between
        // the polygon's X and (X + Width) and its Y and (Y + Height)
        return this.x <= mx && this.x + this.w >= mx && this.y <= my && this.y + this.h >= my
    }
}

export default Polygon
